import React from "react";
import Visor from "./Visor";
import styles from "./MediakitV2.module.scss";

function MediakitV2() {
  return (
    <div className={styles.root}>
      <Visor />
    </div>
  );
}

export default MediakitV2;
